<template src="./Spatial_Intelligence.HTML"></template>
<style src="./Spatial_Intelligence.css" scoped></style>
<script>
import AI_search from './AI_search.vue'
import AI_Zoom from './AI_Zoom.vue'
import AI_LatLong from './AI_LatLong.vue'
import AI_Widgets from './AI_Widgets.vue'
import AI_FeatureList from './AI_FeatureList.vue'
import MMP_ChangePassword from '../shared/MMP_ChangePassword.vue'
import axios from 'axios'
import 'ol/ol.css'
import Attribution from 'ol/control/Attribution'
import Map from 'ol/Map'
import View from 'ol/View'
import { OSM, XYZ } from 'ol/source'
import { Tile as TileLayer } from 'ol/layer'
import {
  get as projGet,
  toLonLat,
  transform,
  transformExtent
} from 'ol/proj'
export default {
  name: 'Spatial_Intelligence',

  components: {
    AI_search,
    MMP_ChangePassword,
    AI_Zoom,
    AI_LatLong,
    AI_Widgets,
    AI_FeatureList
  },
  data() {
    return {
      app: 'Spatial_Intelligence',
      dmpWhiteImg: require('../../../assets/dmpWhite.png'),
      isUshrUser: false,
      mapsMode: false,
      map: null,
      currentBaseMap: null,
      selectedExtent: null,
      drtLayersButtonsCtrl: [],
      ptv_layersObj: {},
      spinnerManager: [],
      layerResponse: null,
      ptv_layers: [],
      lidarIsLoading: false,
      olMapMoveStartKey: null,
      olMapMoveEndKey: null,
      zoomStarted: null,
      zoomControlArr: null,
      shortTermLayerMemory: [],
      zoomEnded: null,
      zoomLevelCap: 13,
      showLidarPanel: false,
      olImageLoadStartKey: null,
      olImageLoadEndKey: null,
      olImageLoadErrorKey: null,
      olTileLoadStartKey: null,
      olTileLoadEndKey: null,
      olTileLoadErrorKey: null,
      olSelectkey: null,
      selectedRelease: null,
      extentResponse: [],
      showAttributes: false,
      vectorLayer: null,
      attributesName: null,
      showMeasuringTool: false,
      showSnippingTool: false,
      polygonVectorLayers: [],
      clickedCoords: null,// Right click coordinates on map,
      showAISearch: true,
      measurement: null,
      polygonsSelected: [],
      polygonSelectEvent: null,
      basemap: false,
      chats: [],
      showFeatures: false
    }
  },
  methods: {
    initAI() {
      if (sessionStorage.token) {
        this.getExtent()
        this.initMaps()
      }
      else { this.$router.push({ name: 'Login' }) }
    },
    initMaps() {
      if (this.map) {
        return;
      }
      this.mapsMode = true
      this.map = new Map({
        controls: [new Attribution({ collapsible: true })],
        target: 'ai-map',
        layers: [
          new TileLayer({
            source: new OSM(),
            name: 'OSM base layer',
            zIndex: 2
          })
        ],
        view: new View({
          center: [0, 0],
          zoom: 4,
          maxZoom: 19,
          constrainResolution: true
        }),
      });
      this.currentBaseMap = 'OpenStreetMap'

      this.map.getViewport().addEventListener('contextmenu', evt => {
        evt.preventDefault()
        let coords = toLonLat(this.map.getEventCoordinate(evt, 'EPSG:4326'))
        this.clickedCoords = coords
      })
    },
    toggleAIsearch() {
      this.showAISearch = !this.showAISearch;
    },
    toggleFeatures() {
      this.showFeatures = !this.showFeatures;
    },
    async transformExtent(extArray) {
      // let extentValues = []
      // let extentCenter = []
      // let arr
      //  arr = extArray.filter(e => e.extent_description == 'North America')
      //  arr[0].extent.split(',').forEach(element => {
      //   extentValues.push(element)
      // })
      // arr[0].extent_center.split(',').forEach(element => {
      //   extentCenter.push(element)
      // })

      let coord = new transformExtent(
        //extentValues,
        // [-116.165039, 29.794893, -49.675781, 52.770870],
        [-217.265636, -17.476442, 48.691396, 72.342461],
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let center = new transform(
        // extentCenter,
        [-112.086920, 39.774768],
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let view;
      view = new View({
        extent: coord,
        center: center,
        constrainOnlyCenter: true,
        zoom: 4.5,
        minZoom: 4.5,
        multiWorld: true
      })

      this.map.setView(view)
    },
    getExtent() {
      if (sessionStorage.token) {
        /* This API call is made to get the response for extent at
        initialization which we can sort further as required.
        This will reduce the additional trip to the backend. */
        axios
          .get(process.env.API_LOCATION + '/api/users/getAllExtents', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getAllExtents API Call Error: ' + content.errors)
            } else {
              this.extentResponse = []
              content.forEach(element => {
                this.extentResponse.push(element)
              })
              // This function assigns extent to the map for North America
              this.transformExtent(this.extentResponse)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    handleMenu(option) {
      if (sessionStorage.token) {
        switch (option) {
          case 'AI':
            this.toggleAIsearch()
            break;
          case 'SignOut':
            sessionStorage.removeItem('token')
            sessionStorage.removeItem('pid')
            sessionStorage.removeItem('sessionId')
            this.$router.push({ name: 'Login' })
            break;
          case 'Map':
            this.basemap = !this.basemap
            this.toggleBaseLayer(this.basemap)
            break;
          case 'Features':
            this.toggleFeatures()
            break;


        }
      } else { this.$router.push({ name: 'Login' }) }
    },
    toggleBaseLayer(newBaseLayer) {
      // Remove any existing base layers first
      this.map.getLayers().forEach(layer => {
        if (layer != undefined) {
          const name = layer.get('name');
          if (name === 'OSM base layer' || name === 'Azure base layer') {
            this.map.removeLayer(layer);
          }
        }
      });

      // Add the desired base layer
      let baseLayer;

      if (newBaseLayer === true) {
        baseLayer = new TileLayer({
          source: new XYZ({
            url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&subscription-key=${process.env.AZURE_MAPS_KEY}`,
            attributions: '© Microsoft Azure Maps',
            // Azure 'microsoft.imagery' tiles only exist up to zoom 19.
            // Cap the tile grid so OpenLayers over-zooms (upscales) the z19
            // tiles past 19 instead of requesting missing tiles (black map).
            maxZoom: 19
          }),
          name: 'Azure base layer',
          zIndex: 2
        });
      } else {
        baseLayer = new TileLayer({
          source: new OSM(),
          name: 'OSM base layer',
          zIndex: 1
        });
      }

      // Insert new base layer at index 0
      this.map.getLayers().insertAt(0, baseLayer);
    },
     async addPoint(feature) {
      this.map.removeLayer(this.vectorLayer);
      this.vectorLayer = null

      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [feature]
        }),
        zIndex: 1000
      })

      this.map.addLayer(this.vectorLayer)
    },

  },
  mounted() {
    this.initAI()
    if (!sessionStorage.pid && !typeof sessionStorage.pid == "string") {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
      sessionStorage.removeItem('sessionId')
      this.$router.push({ name: 'Login' })
    }
  },
}
</script>
